export interface Country {
  code: string
  name: string
  phonePrefix: string
  flag: string
}

export const countries: Country[] = [
  {
    code: 'VN',
    name: 'Vietnam',
    phonePrefix: '+84',
    flag: '🇻🇳'
  },
  {
    code: 'US',
    name: 'United States',
    phonePrefix: '+1',
    flag: '🇺🇸'
  },
  {
    code: 'GB',
    name: 'United Kingdom',
    phonePrefix: '+44',
    flag: '🇬🇧'
  },
  {
    code: 'CN',
    name: 'China',
    phonePrefix: '+86',
    flag: '🇨🇳'
  },
  {
    code: 'JP',
    name: 'Japan',
    phonePrefix: '+81',
    flag: '🇯🇵'
  },
  {
    code: 'KR',
    name: 'South Korea',
    phonePrefix: '+82',
    flag: '🇰🇷'
  },
  {
    code: 'SG',
    name: 'Singapore',
    phonePrefix: '+65',
    flag: '🇸🇬'
  },
  {
    code: 'MY',
    name: 'Malaysia',
    phonePrefix: '+60',
    flag: '🇲🇾'
  },
  {
    code: 'TH',
    name: 'Thailand',
    phonePrefix: '+66',
    flag: '🇹🇭'
  },
  {
    code: 'ID',
    name: 'Indonesia',
    phonePrefix: '+62',
    flag: '🇮🇩'
  },
  {
    code: 'PH',
    name: 'Philippines',
    phonePrefix: '+63',
    flag: '🇵🇭'
  },
  {
    code: 'AU',
    name: 'Australia',
    phonePrefix: '+61',
    flag: '🇦🇺'
  },
  {
    code: 'NZ',
    name: 'New Zealand',
    phonePrefix: '+64',
    flag: '🇳🇿'
  },
  {
    code: 'CA',
    name: 'Canada',
    phonePrefix: '+1',
    flag: '🇨🇦'
  },
  {
    code: 'DE',
    name: 'Germany',
    phonePrefix: '+49',
    flag: '🇩🇪'
  },
  {
    code: 'FR',
    name: 'France',
    phonePrefix: '+33',
    flag: '🇫🇷'
  },
  {
    code: 'IT',
    name: 'Italy',
    phonePrefix: '+39',
    flag: '🇮🇹'
  },
  {
    code: 'ES',
    name: 'Spain',
    phonePrefix: '+34',
    flag: '🇪🇸'
  },
  {
    code: 'PT',
    name: 'Portugal',
    phonePrefix: '+351',
    flag: '🇵🇹'
  },
  {
    code: 'NL',
    name: 'Netherlands',
    phonePrefix: '+31',
    flag: '🇳🇱'
  },
  {
    code: 'BE',
    name: 'Belgium',
    phonePrefix: '+32',
    flag: '🇧🇪'
  },
  {
    code: 'CH',
    name: 'Switzerland',
    phonePrefix: '+41',
    flag: '🇨🇭'
  },
  {
    code: 'AT',
    name: 'Austria',
    phonePrefix: '+43',
    flag: '🇦🇹'
  },
  {
    code: 'SE',
    name: 'Sweden',
    phonePrefix: '+46',
    flag: '🇸🇪'
  },
  {
    code: 'NO',
    name: 'Norway',
    phonePrefix: '+47',
    flag: '🇳🇴'
  },
  {
    code: 'DK',
    name: 'Denmark',
    phonePrefix: '+45',
    flag: '🇩🇰'
  },
  {
    code: 'FI',
    name: 'Finland',
    phonePrefix: '+358',
    flag: '🇫🇮'
  },
  {
    code: 'PL',
    name: 'Poland',
    phonePrefix: '+48',
    flag: '🇵🇱'
  },
  {
    code: 'CZ',
    name: 'Czech Republic',
    phonePrefix: '+420',
    flag: '🇨🇿'
  },
  {
    code: 'SK',
    name: 'Slovakia',
    phonePrefix: '+421',
    flag: '🇸🇰'
  },
  {
    code: 'HU',
    name: 'Hungary',
    phonePrefix: '+36',
    flag: '🇭🇺'
  },
  {
    code: 'RO',
    name: 'Romania',
    phonePrefix: '+40',
    flag: '🇷🇴'
  },
  {
    code: 'BG',
    name: 'Bulgaria',
    phonePrefix: '+359',
    flag: '🇧🇬'
  },
  {
    code: 'GR',
    name: 'Greece',
    phonePrefix: '+30',
    flag: '🇬🇷'
  },
  {
    code: 'TR',
    name: 'Turkey',
    phonePrefix: '+90',
    flag: '🇹🇷'
  },
  {
    code: 'IL',
    name: 'Israel',
    phonePrefix: '+972',
    flag: '🇮🇱'
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
    phonePrefix: '+971',
    flag: '🇦🇪'
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
    phonePrefix: '+966',
    flag: '🇸🇦'
  },
  {
    code: 'QA',
    name: 'Qatar',
    phonePrefix: '+974',
    flag: '🇶🇦'
  },
  {
    code: 'KW',
    name: 'Kuwait',
    phonePrefix: '+965',
    flag: '🇰🇼'
  },
  {
    code: 'BH',
    name: 'Bahrain',
    phonePrefix: '+973',
    flag: '🇧🇭'
  },
  {
    code: 'OM',
    name: 'Oman',
    phonePrefix: '+968',
    flag: '🇴🇲'
  },
  {
    code: 'IN',
    name: 'India',
    phonePrefix: '+91',
    flag: '🇮🇳'
  },
  {
    code: 'PK',
    name: 'Pakistan',
    phonePrefix: '+92',
    flag: '🇵🇰'
  },
  {
    code: 'BD',
    name: 'Bangladesh',
    phonePrefix: '+880',
    flag: '🇧🇩'
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
    phonePrefix: '+94',
    flag: '🇱🇰'
  },
  {
    code: 'NP',
    name: 'Nepal',
    phonePrefix: '+977',
    flag: '🇳🇵'
  },
  {
    code: 'BT',
    name: 'Bhutan',
    phonePrefix: '+975',
    flag: '🇧🇹'
  },
  {
    code: 'MV',
    name: 'Maldives',
    phonePrefix: '+960',
    flag: '🇲🇻'
  },
  {
    code: 'MM',
    name: 'Myanmar',
    phonePrefix: '+95',
    flag: '🇲🇲'
  },
  {
    code: 'LA',
    name: 'Laos',
    phonePrefix: '+856',
    flag: '🇱🇦'
  },
  {
    code: 'KH',
    name: 'Cambodia',
    phonePrefix: '+855',
    flag: '🇰🇭'
  },
  {
    code: 'BN',
    name: 'Brunei',
    phonePrefix: '+673',
    flag: '🇧🇳'
  },
  {
    code: 'TL',
    name: 'Timor-Leste',
    phonePrefix: '+670',
    flag: '🇹🇱'
  }
]

// Helper functions
export const getCountryByCode = (code: string): Country | undefined => {
  return countries.find(country => country.code === code)
}

export const getCountryByPhonePrefix = (prefix: string): Country | undefined => {
  return countries.find(country => country.phonePrefix === prefix)
}

export const getCountryOptions = () => {
  return countries.map(country => ({
    value: country.code,
    label: `${country.flag} ${country.name}`
  }))
}

export const getCountryPhoneOptions = () => {
  return countries.map(country => ({
    value: country.phonePrefix,
    label: `${country.flag} ${country.name} ${country.phonePrefix}`,
    code: country.code
  }))
}
